export default {
  MapClassificationInfo: {
    code: 1,
    data: [
      {
        groupCode: 'A',
        groupName: '飯糰手卷',
        categories: [
          {
            categoryCode: '061',
            categoryName: '飯糰',
            products: [
              {
                productCode: '0610001',
                productName: '肉鬆飯糰',
              },
              {
                productCode: '0610002',
                productName: '鮪魚飯糰',
              },
            ],
          },
          {
            categoryCode: '063',
            categoryName: '飯糰+手卷',
            products: [
              {
                productCode: '0630001',
                productName: '牛肉飯糰手卷',
              },
            ],
          },
          {
            categoryCode: '065',
            categoryName: '手卷',
            products: [
              {
                productCode: '0650001',
                productName: '蔬菜手卷',
              },
            ],
          },
        ],
      },
      {
        groupCode: 'B',
        groupName: '飯糰手卷B',
        categories: [
          {
            categoryCode: '061B',
            categoryName: '飯糰B',
            products: [
              {
                productCode: '0610001B',
                productName: '肉鬆飯糰B',
              },
              {
                productCode: '0610002B',
                productName: '鮪魚飯糰B',
              },
            ],
          },
          {
            categoryCode: '063B',
            categoryName: '飯糰+手卷B',
            products: [
              {
                productCode: '0630001B',
                productName: '牛肉飯糰手卷B',
              },
            ],
          },
          {
            categoryCode: '065B',
            categoryName: '手卷B',
            products: [
              {
                productCode: '0650001B',
                productName: '蔬菜手卷B',
              },
            ],
          },
        ],
      },
      {
        groupCode: 'D',
        groupName: '三明治沙拉',
        categories: [
          {
            categoryCode: '106',
            categoryName: '三明治',
            products: [
              {
                productCode: '1060001',
                productName: '紐奧良雞腿三明治',
              },
              {
                productCode: '1060002',
                productName: '起司三明治',
              },
            ],
          },
          {
            categoryCode: '107',
            categoryName: '沙拉',
            products: [
              {
                productCode: '1070001',
                productName: '水果沙拉',
              },
            ],
          },
        ],
      },
    ],
    message: '成功',
  },
  Inventory: {
    code: 1,
    data: [
      {
        oldPKey: '000003',
        name: '全家延吉店',
        longitude: 121.55303,
        latitude: 25.03962,
        address: '台北市大安區忠孝東路四段216巷31號',
        updateDate: '2021-03-03T13:00:00+08:00',
        info: [
          {
            code: '17',
            qty: 15,
            categories: [
              {
                code: '061',
                qty: 10,
                products: [
                  {
                    code: '0610001',
                    qty: 7,
                  },
                  {
                    code: '0610002',
                    qty: 3,
                  },
                ],
              },
              {
                code: '063',
                qty: 5,
                products: [
                  {
                    code: '0630001',
                    qty: 5,
                  },
                ],
              },
              {
                code: '065',
                qty: 0,
                products: [
                  {
                    // code: '0650001',
                    // qty: 0,
                  },
                ],
              },
            ],
          },
          {
            code: '20',
            qty: 7,
            categories: [
              {
                code: '121',
                qty: 4,
                products: [
                  {
                    code: '1210001',
                    qty: 3,
                  },
                  {
                    code: '1210002',
                    qty: 1,
                  },
                ],
              },
              {
                code: '107',
                qty: 3,
                products: [
                  {
                    code: '1070001',
                    qty: 3,
                  },
                ],
              },
            ],
          },
          {
            code: '18',
            qty: 0,
            categories: [
              // {
              //   code: '123',
              //   qty: 0,
              //   products: [
              //     {
              //       code: '1230001',
              //       qty: 0,
              //     },
              //     {
              //       code: '1230002',
              //       qty: 0,
              //     },
              //   ],
              // },
              // {
              //   code: '125',
              //   qty: 0,
              //   products: [
              //     {
              //       code: '1250005',
              //       qty: 0,
              //     },
              //     {
              //       code: '1250004',
              //       qty: 0,
              //     },
              //   ],
              // },
            ],
          },
          {
            code: '19',
            qty: 0,
            categories: [],
          },
        ],
      },
      {
        oldPKey: '000007',
        name: '全家中崙店',
        longitude: 121.5526,
        latitude: 25.046288,
        address: '台北市松山區八德路三段74巷43號',
        updateDate: '2021-03-03T13:00:00+08:00',
        info: [
          {
            code: '17',
            qty: 14,
            categories: [
              {
                code: '061',
                qty: 9,
                products: [
                  {
                    code: '0610001',
                    qty: 6,
                  },
                  {
                    code: '0610002',
                    qty: 3,
                  },
                ],
              },
              {
                code: '063',
                qty: 0,
                products: [
                  // {
                  //   code: '0630001',
                  //   qty: 0,
                  // },
                ],
              },
              {
                code: '065',
                qty: 5,
                products: [
                  {
                    code: '0650001',
                    qty: 5,
                  },
                ],
              },
            ],
          },
          {
            code: '20',
            qty: 9,
            categories: [
              {
                code: '121',
                qty: 6,
                products: [
                  {
                    code: '1210001',
                    qty: 4,
                  },
                  {
                    code: '1210002',
                    qty: 2,
                  },
                ],
              },
              {
                code: '107',
                qty: 3,
                products: [
                  {
                    code: '1070001',
                    qty: 3,
                  },
                ],
              },
            ],
          },
          {
            code: '18',
            qty: 8,
            categories: [
              {
                code: '123',
                qty: 5,
                products: [
                  {
                    code: '1230005',
                    qty: 5,
                  },
                ],
              },
              {
                code: '125',
                qty: 3,
                products: [
                  {
                    code: '1250005',
                    qty: 2,
                  },
                  {
                    code: '1250004',
                    qty: 1,
                  },
                ],
              },
            ],
          },
          {
            code: '19',
            qty: 0,
            categories: [],
          },
        ],
      },
      {
        oldPKey: '000087',
        name: '全家中二店',
        longitude: 121.51,
        latitude: 25.047,
        address: '台北市大安區忠孝東路四段216巷31號',
        updateDate: '2021-03-03T13:00:00+08:00',
        info: [
          {
            code: '17',
            qty: 0,
            categories: [
              // {
              //   code: '061',
              //   qty: 0,
              //   products: [
              //     {
              //       code: '0610001',
              //       qty: 0,
              //     },
              //     {
              //       code: '0610002',
              //       qty: 0,
              //     },
              //   ],
              // },
              // {
              //   code: '063',
              //   qty: 0,
              //   products: [
              //     {
              //       code: '0630001',
              //       qty: 0,
              //     },
              //   ],
              // },
              // {
              //   code: '065',
              //   qty: 0,
              //   products: [
              //     {
              //       code: '0650001',
              //       qty: 0,
              //     },
              //   ],
              // },
            ],
          },
          {
            code: '20',
            qty: 0,
            categories: [
              // {
              //   code: '121',
              //   qty: 0,
              //   products: [
              //     {
              //       code: '1210001',
              //       qty: 0,
              //     },
              //   ],
              // },
            ],
          },
          {
            code: '18',
            qty: 0,
            categories: [
              // {
              //   code: '123',
              //   qty: 0,
              //   products: [
              //     {
              //       code: '1230001',
              //       qty: 0,
              //     },
              //     {
              //       code: '1230002',
              //       qty: 0,
              //     },
              //   ],
              // },
              // {
              //   code: '125',
              //   qty: 0,
              //   products: [
              //     {
              //       code: '1250005',
              //       qty: 0,
              //     },
              //     {
              //       code: '1250004',
              //       qty: 0,
              //     },
              //   ],
              // },
            ],
          },
          {
            code: '19',
            qty: 0,
            categories: [],
          },
        ],
      },
      {
        oldPKey: '000088',
        name: '全家中三店',
        longitude: 121.5301401546066,
        latitude: 25.05169061841411,
        address: '台北市松山區八德路三段74巷43號',
        updateDate: '2021-03-03T13:00:00+08:00',
        info: [
          {
            code: '17',
            qty: 0,
            categories: [],
          },
          {
            code: '20',
            qty: 9,
            categories: [
              {
                code: '121',
                qty: 6,
                products: [
                  {
                    code: '1210001',
                    qty: 4,
                  },
                  {
                    code: '1210002',
                    qty: 2,
                  },
                ],
              },
              {
                code: '107',
                qty: 3,
                products: [
                  {
                    code: '1070001',
                    qty: 3,
                  },
                ],
              },
            ],
          },
          {
            code: '18',
            qty: 8,
            categories: [
              {
                code: '123',
                qty: 5,
                products: [
                  {
                    code: '1230005',
                    qty: 5,
                  },
                ],
              },
              {
                code: '125',
                qty: 3,
                products: [
                  {
                    code: '1250005',
                    qty: 2,
                  },
                  {
                    code: '1250004',
                    qty: 1,
                  },
                ],
              },
            ],
          },
          {
            code: '19',
            qty: 25,
            categories: [
              {
                code: '333',
                qty: 14,
                products: [
                  {
                    code: '3330005',
                    qty: 14,
                  },
                ],
              },
              {
                code: '334',
                qty: 11,
                products: [
                  {
                    code: '3340005',
                    qty: 2,
                  },
                  {
                    code: '3340004',
                    qty: 9,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    message: '成功',
  },
  MapProductInfo: {
    code: 1,
    data: [
      {
        oldPKey: '000088',
        name: '全家延吉店',
        tel: '02-27412630',
        longitude: 121.5191384128393,
        latitude: 25.057390452592501,
        distance: 1300,
        address: '台北市大安區忠孝東路四段216巷31號',
        updateDate: '2021-03-03T13:00:00+08:00',
        info: [],
      },
      {
        oldPKey: '000003',
        name: '全家延吉店2',
        tel: '02-27412630',
        longitude: 121.53127044735733,
        latitude: 25.066546131262076,
        distance: 1300,
        address: '台北市大安區忠孝東路四段216巷31號',
        updateDate: '2021-03-03T13:00:00+08:00',
        info: [
          {
            code: 'A',
            name: '飯糰手卷',
            iconImgUrl: 'https://stampt.family.com.tw/MapImage/icon5.svg',
            qty: 0,
            categories: [],
          },
          {
            code: 'D',
            name: '三明治沙拉',
            iconImgUrl: 'https://stampt.family.com.tw/MapImage/icon.svg',
            qty: 7,
            categories: [
              {
                code: '106',
                name: '三明治',
                qty: 4,
                products: [
                  {
                    code: '1060001',
                    name: '紐奧良雞腿三明治',
                    qty: 3,
                  },
                  {
                    code: '1060002',
                    name: '起司三明治',
                    qty: 1,
                  },
                ],
              },
              {
                code: '107',
                name: '沙拉',
                qty: 3,
                products: [
                  {
                    code: '1070001',
                    name: '水果沙拉',
                    qty: 3,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        oldPKey: '000089',
        name: '全家延吉店3',
        tel: '02-27412630',
        longitude: 121.5301401546066,
        latitude: 25.05169061841411,
        distance: 0,
        address: '台北市大安區忠孝東路四段216巷31號',
        updateDate: '2021-03-03T13:00:00+08:00',
        info: [
          {
            code: 'A',
            name: '飯糰手卷',
            iconImgUrl: 'https://stampt.family.com.tw/MapImage/icon.svg',
            qty: 15,
            categories: [
              {
                code: '061',
                name: '飯糰',
                qty: 10,
                products: [
                  {
                    code: '0610001',
                    name: '肉鬆飯糰',
                    qty: 7,
                  },
                  {
                    code: '0610002',
                    name: '蝦鬆飯糰',
                    qty: 3,
                  },
                ],
              },
              {
                code: '065',
                name: '手卷',
                qty: 5,
                products: [
                  {
                    code: '0650001',
                    name: '蔬菜手卷',
                    qty: 5,
                  },
                ],
              },
            ],
          },
          {
            code: 'D',
            name: '三明治沙拉',
            iconImgUrl: 'https://stampt.family.com.tw/MapImage/icon.svg',
            qty: 7,
            categories: [
              {
                code: '106',
                name: '三明治',
                qty: 4,
                products: [
                  {
                    code: '1060001',
                    name: '紐奧良雞腿三明治',
                    qty: 3,
                  },
                  {
                    code: '1060002',
                    name: '起司三明治',
                    qty: 1,
                  },
                ],
              },
              {
                code: '107',
                name: '沙拉',
                qty: 3,
                products: [
                  {
                    code: '1070001',
                    name: '水果沙拉',
                    qty: 3,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    message: '成功',
  },
  MapList: {
    code: 1,
    data: [
      {
        projectCode: '202205311',
        name: '限店美食瘋',
        copyWrite:
          '全家便利商店好物推薦*發現全家好商品！推薦你看看【限店美食瘋】',
        hexList: [
          {
            hex0: '#f2be04',
            hex1: '#eaba13',
            hex2: '#f7d5ee',
            hex3: '#fbf7ec',
          },
        ],
        iconCount: 6,
        mapImgUrl: 'https://stampt.family.com.tw/***********.jpg',
        popimgUrl: 'https://stampt.family.com.tw/MapImage/popImage.jpg',
        status: 1,
        sort: 0,
        mapUrl: 'https://d33qm0lkzpr1fa.cloudfront.net/',
        longestDistance: 2,
        specifiedUrl: null,
      },
      {
        projectCode: '202112071',
        name: '聯名地圖',
        copyWrite:
          '全家便利商店好物推薦*發現全家好商品！推薦你看看【聯名地圖】',
        hexList: [
          {
            hex0: '#008cd6',
            hex1: '#007bbc',
            hex2: '#5cb5e5',
            hex3: '#e9f6fe',
          },
        ],
        iconCount: 6,
        mapImgUrl: 'https://stampt.family.com.tw/***********.jpg',
        popimgUrl: 'https://stampt.family.com.tw/MapImage/popImage.jpg',
        status: 1,
        sort: 1,
        mapUrl: 'https://d33qm0lkzpr1fa.cloudfront.net/',
        longestDistance: 2,
        specifiedUrl: null,
      },
      {
        projectCode: '202206281',
        name: '蔬食地圖',
        copyWrite:
          '全家便利商店好物推薦*發現全家好商品！推薦你看看【蔬食地圖】',
        hexList: [
          {
            hex0: '#008cd6',
            hex1: '#007bbc',
            hex2: '#5cb5e5',
            hex3: '#e9f6fe',
          },
        ],
        iconCount: 6,
        mapImgUrl: 'https://stampt.family.com.tw/***********.jpg',
        popimgUrl: 'https://stampt.family.com.tw/MapImage/popImage.jpg',
        status: 0,
        sort: 2,
        mapUrl: 'https://d33qm0lkzpr1fa.cloudfront.net/',
        longestDistance: 2,
        specifiedUrl: null,
      },
      {
        projectCode: '202106302',
        name: '友善食光地圖',
        copyWrite:
          '全家便利商店好物推薦*發現全家好商品！推薦你看看【蔬食地圖】',
        hexList: [
          {
            hex0: '#008cd6',
            hex1: '#007bbc',
            hex2: '#5cb5e5',
            hex3: '#e9f6fe',
          },
        ],
        iconCount: 6,
        mapImgUrl: 'https://stampt.family.com.tw/***********.jpg',
        popimgUrl: 'https://stampt.family.com.tw/MapImage/popImage.jpg',
        status: 1,
        sort: 2,
        mapUrl: 'https://d33qm0lkzpr1fa.cloudfront.net/',
        longestDistance: 2,
        specifiedUrl: null,
      },
      {
        projectCode: '202208205',
        name: '加熱菸地圖',
        copyWrite:
          '全家便利商店好物推薦*發現全家好商品！推薦你看看【蔬食地圖】',
        hexList: [
          {
            hex0: '#008cd6',
            hex1: '#007bbc',
            hex2: '#5cb5e5',
            hex3: '#e9f6fe',
          },
        ],
        iconCount: 6,
        mapImgUrl:
          'https://stampt.family.com.tw/MapImage/0a2782c70f714142bfe13036bbc877a6.jpg',
        popimgUrl:
          'https://stampt.family.com.tw/MapImage/20518e8f642447eb8db2eac9baf1a163.jpg',
        status: 1,
        sort: 2,
        mapUrl: 'https://d33qm0lkzpr1fa.cloudfront.net/',
        longestDistance: 2,
        specifiedUrl: 'https://fix.family.com',
      },
    ],
    message: '成功',
  },
};
